import React from 'react';

/**
 * Ranking Badge Component - Minimalist Version
 * Simple number without background badge
 */
const RankingBadge = ({ rank }) => {
  if (!rank) return null;

  const isTopThree = rank <= 3;
  
  // Colors for top 3
  const rankColors = {
    1: 'text-yellow-400', // Gold
    2: 'text-gray-300',   // Silver
    3: 'text-amber-700'   // Bronze
  };

  const textColor = isTopThree ? rankColors[rank] : 'text-gray-600';
  const textSize = isTopThree ? 'text-3xl' : 'text-xl';
  const fontWeight = isTopThree ? 'font-black' : 'font-bold';

  return (
    <div className="absolute top-3 right-3 z-10">
      <span 
        className={`${textColor} ${textSize} ${fontWeight}`}
        style={{ 
          textShadow: '2px 2px 4px rgba(0,0,0,0.5), -1px -1px 2px rgba(0,0,0,0.3)' 
        }}
      >
        #{rank}
      </span>
    </div>
  );
};

export default RankingBadge;
